import React, { useState, useEffect } from 'react';

interface ImageProps {
  imageClass: string;
  src: string;
  alt: string;
  width?: number;
  height?: number;
  ariaLabel: string;
  handleImageClick?: () => void;
  tabindex?:number;
}
const Image: React.FC<ImageProps> = ({
  imageClass,
  src,
  alt,
  width,
  height,
  ariaLabel,
  handleImageClick,
  tabindex,
}) => {
  useEffect(() => {});

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleImageClick();
    }
  };

  return (
    <div>
      <img
        className={`${imageClass}`}
        src={src}
        alt={alt}
        width={width}
        height={height}
        aria-label={ariaLabel}
        tabIndex={tabindex}
        onClick={handleImageClick}
        onKeyPress={handleKeyPress}
      />
    </div>
  );
};

export default Image;
